export const ENDPOINT = {
    GET_LEGAL_AGREEMENT: "bank/bankdetail/",
    POST_LEGAL_AGREEMENT: "bank/bankdetail/",
};
